import axios, { AxiosInstance } from 'axios';

import { APP_NAME } from '../../constants/app';
import { getTimeZone } from '../../../utilities/common/date';
import { onResponseFulfilled, onResponseRejected } from './response';
import { onRequestFulfilled, onRequestRejected } from './request';

interface NetworkRequest {
  url: string;
  body?: any;
  headers?: Record<string, any>;
  params?: Record<string, any>;
}

class Network {
  client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: import.meta.env.VITE_API_BASE_URL,
      timeout: 30000,
    });
    this.#attachCommonHeaders();
    this.#attachInterceptors();
  }

  get = async (request: NetworkRequest) => {
    return this.client.get(request.url, {
      params: request.params,
      headers: request.headers,
    });
  };

  post = async (request: NetworkRequest) => {
    return this.client.post(request.url, request.body, {
      params: request.params,
      headers: request.headers,
    });
  };

  delete = async (request: NetworkRequest) => {
    return this.client.delete(request.url, {
      params: request.params,
      headers: request.headers,
    });
  };

  #attachCommonHeaders = () => {
    this.client.defaults.withCredentials = true;
    this.client.defaults.headers.common.timezone = getTimeZone();
    this.client.defaults.headers.common.language =
      import.meta.env.VITE_DEFAULT_LANG || 'en';
    this.client.defaults.headers.common.source = APP_NAME;
    this.client.defaults.headers.common['Content-Type'] =
      'application/json; charset=utf-8';

    const orgId = localStorage.getItem('org_id');
    if (orgId) {
      this.client.defaults.headers.common['organisationid'] = orgId;
    }
  };

  #attachInterceptors = () => {
    this.client.interceptors.request.use(onRequestFulfilled, onRequestRejected);
    this.client.interceptors.response.use(
      onResponseFulfilled,
      onResponseRejected,
    );
  };
}

const network = new Network();
export default network;
